import 'animate.css';
import { Col, Container, Row } from "react-bootstrap";
import TrackVisibility from 'react-on-screen';
import colorSharp2 from "../assets/img/color-sharp2.png";
import expense from "../assets/img/expenseTrackerApp.png";
import notesMock from "../assets/img/notesMock.png";
import png from "../assets/img/png.png";
import { ProjectCard } from "./ProjectCard";

export const Projects = () => {

  const projects = [
    {
      title: "Budget Tracker",
      description: "A simple budget tracking app to manage your finances efficiently by tracking expenses, categorizing spending, and visualizing financial data",
      imgUrl: expense,
    },
    {
      title: "Notes App",
      description: "This is a basic Note making android application written in Kotlin. This application enables the user to Create, Read, Update and Delte their notes. We store the data of the notes using a local database using ROOM Database library. We have also implemented Co-routines to make the I/O operations quick and smooth so that our app is lag-free.",
      imgUrl: notesMock,
    },
    {
      title: "75 Hard Challenge App",
      description: "Building the foundation for a stronger generation A tool to build a disciplined and healthy lifestyle ",
      imgUrl: png,
    }
  ];

  return (
    <section className="project" id="project">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) =>
              <div className={isVisible ? "animate__animated animate__fadeIn": ""}>
                <h2>Projects</h2>
                <p>                        As an Android developer, I've built numerous projects using Kotlin. 
                        Kotlin's concise and expressive syntax allowed me to write efficient code resulting in faster development times and easier maintenance. 
                        I'm passionate about creating intuitive and beautiful user interfaces. With my skills and experience, I can bring your ideas to life and create amazing Android apps.
</p>
                <Row>
               
                        {
                          projects.map((project, index) => {
                            return (
                              <ProjectCard
                                key={index}
                                {...project}
                                />
                            )
                          })
                        }
                      </Row>
                      
              </div>}
              
            </TrackVisibility>
            
          </Col>
        </Row>
      </Container>
      <img className="background-image-right" src={colorSharp2}></img>
    </section>
  )
}